import {useFirebaseState} from "./firebaseContext";
import {useEffect, useState} from "react";
import {doc, updateDoc, getDoc, setDoc, collection, deleteDoc} from 'firebase/firestore'

export const useArticle = id => {
    const [article, setArticle] = useState({});
    const {db} = useFirebaseState();

    useEffect(() => {
        let isMounted = true;
        if(db && id) {
            const newsRef = doc(db, 'news', id);
            getDoc(newsRef)
            .then(docSnap => {
                if (isMounted) {
                    const exists = typeof docSnap.exists === "function" ? docSnap.exists() : docSnap.exists;
                    setArticle(exists ? docSnap.data() : {});
                }
            })
            .catch(() => {
                if (isMounted) setArticle({});
            });
        } else {
            setArticle({
                text: "",
                media: null,
                title: ""
            });
        }
        return () => {
            isMounted = false;
        };
    }, [db, id])

    const updateArticle = (id, updatedArticle) => {
        const publishedDate = updatedArticle?.published || article?.published || new Date();
        if(db && id) {
            const newsRef  = doc(db, 'news', id)
            return updateDoc(
                newsRef,
                {
                    ...updatedArticle,
                    published: publishedDate,
                    updatedAt: new Date()
                }
            )
        } else if(db) {
            const newsRef = collection(db, 'news')
            return setDoc(
                doc(newsRef),
                {
                    ...updatedArticle,
                    published: publishedDate,
                    createdAt: new Date(),
                    updatedAt: new Date()
                }
            )
        }
    }

    const deleteArticle = id => {
        if(db && id) {
            const newsDoc  = doc(db, 'news', id)
            return deleteDoc(newsDoc)
        }
    }

    return {
        article: article,
        updateArticle: updateArticle,
        deleteArticle: deleteArticle
    }
}